module.exports = __webpack_public_path__ + "img/estate-cover.9a3afa84.jpg";